import {Box, Typography, Tooltip} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import UploadIconWhite from '../assets/icons/upload_white_256.png';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
        maxWidth: 300,
        maxHeight: 400,
        cursor: 'pointer',
        width: '100%',
        height: '100%',
        margin: 'auto',
        background: '#383c42',
        borderRadius: theme.shape.borderRadius,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        transition: theme.transitions.create('all', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        '&:hover': {
            boxShadow: '0 4px 4px #000'
        },
        '& img': {
            boxSizing: 'border-box',
            borderRadius: theme.shape.borderRadius,
            width: '100%',
            maxWidth: 200,
            maxHeight: 200,
            objectFit: 'cover',
            margin: 'auto',
            aspectRatio: '1',
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
        },
        '& > .MuiSvgIcon-root': {
            height: 200,
            width: 200,
            margin: 'auto',
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
        }
    }
}));

export default function StackCard({title, imageCount, children, onClick, images}) {
    const classes = useStyles();
    return (
        <Box className={classes.root} onClick={onClick}>
            <Tooltip title={title}>
                <Typography variant="h6" style={{width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', height: 'auto', whiteSpace: 'nowrap'}}>{title}</Typography>
            </Tooltip>
            {imageCount === 0 ? <img src={UploadIconWhite} alt="upload" style={{height: 100, width: 100, marginTop: 50, marginBottom: 75}} /> : <img src={images[0].editedUri} alt="preview" />}
            <Typography variant="body2" style={{marginBottom: 8}}>{imageCount} pictures</Typography>
            <div style={{flex: '1'}} />
            {children}
        </Box>
    )
}
